import { formatLongDate, formatTime } from '@/utils/dateFormatter';

export function formatPenyelenggara(value) {
  const labels = {
    'PT BORNEO INDOBARA': 'Borneo Indobara',
    'PT CIPTA KRIDATAMA': 'Cipta Kridatama',
    'PT TAMA MULIA RESOURCES': 'Tama Mulia Resources',
    'PT PUTRA PERKASA ABADI': 'Putra Perkasa Abadi'
  };
  return labels[value] || value || '-';
}

export function formatBatchLabel(item) {
  const raw = item?.batch ?? item?.batch_number;
  if (raw === undefined || raw === null || raw === '') return 'Batch';

  const text = String(raw).trim();
  if (!text) return 'Batch';
  if (/^batch\b/i.test(text)) {
    return text.replace(/^batch\s*/i, 'Batch ').trim();
  }

  return `Batch ${text}`;
}

export function normalizeBatchList(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.batches)) return data.batches;
  return [];
}

function toDisplaySchedule(schedule) {
  const start = formatTime(schedule.start_time);
  const end = formatTime(schedule.end_time);

  return {
    date: formatLongDate(schedule.date) || '-',
    time: start && end ? `${start} - ${end}` : (start || end)
  };
}

export function getBatchSchedules(batch) {
  if (!batch) return [];

  const source = Array.isArray(batch.schedules)
    ? batch.schedules.filter((schedule) => schedule?.date)
    : [];

  if (!source.length) {
    if (!batch.start_date) return [];
    return [toDisplaySchedule({
      date: batch.start_date,
      start_time: batch.start_time,
      end_time: batch.end_time
    })];
  }

  if (source.length > 1) {
    source.sort((a, b) => String(a.date).localeCompare(String(b.date)));
  }

  return source.map(toDisplaySchedule);
}
